import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-13b8710c")

_pushScopeId("data-v-13b8710c")
const _hoisted_1 = {
  class: "pond-list-item",
  "data-test": "pondListItem"
}
const _hoisted_2 = { class: "pond" }
const _hoisted_3 = { class: "pond__name" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "pond__edit" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-angle-right" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ['status', _ctx.statusStyle]
    }, null, 2),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.pond.name), 1),
      _hoisted_4
    ])
  ]))
})